import { LspModuleData } from 'types';
import { service } from '.';
import { cookies } from 'static';

const getToken = () => {
  const stored = localStorage.getItem(cookies.FarmersPlanToken);
  return stored ? JSON.parse(stored)?.token : undefined;
};

export const getAllModules = (): Promise<LspModuleData[]> => {
  return service('/api/v1/modules/all', { method: 'GET' }, getToken()) as Promise<LspModuleData[]>;
};

export const selfAddModuleToAccount = (moduleId: string | number) =>
  service(
    '/api/v1/modules/self-account-add-module',
    {
      method: 'POST',
      params: { moduleId: String(moduleId) },
    },
    getToken(),
  );

export const selfRemoveModuleFromAccount = (moduleId: string | number) =>
  service(
    '/api/v1/modules/self-account-remove-module',
    {
      method: 'POST',
      params: { moduleId: String(moduleId) },
    },
    getToken(),
  );
